import { render, staticRenderFns } from "./BlocInfos.vue?vue&type=template&id=30b9ae6e&"
import script from "./BlocInfos.vue?vue&type=script&lang=js&"
export * from "./BlocInfos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports